import CRUD from '../base/crud'

const apiKey = process.env.REACT_APP_HELP_SUPPORT_API_KEY

class HelpSupportCRUD extends CRUD {


    sendHelpSupportForm(data) {
        return this.request({
            url: '/help',
            method: 'POST',
            data,
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
        })
    }
}

export default function helpSupportCRUD(request) {
    return new HelpSupportCRUD({
        url: '/help',
        request,
    })
}
